import { atom } from "recoil";
import { User } from "../utils/Types";

const userInfoAtom = atom<User | null>({
  key: "userInfo",
  default: null,
});

export default userInfoAtom;
